import { type FunctionComponent } from 'react';

import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import BreakoutRoomRowItem from './BreakoutRoomRowItem';
import BreakoutRoomOptionsContainer from '../BreakoutRoomOptionsContainer';
import { StyledPanelContainer } from '../styles/styled-components';

const BreakoutRoomRowCollection: FunctionComponent = () => {
    const { ready } = useTranslation();
    const { roomState } = useContainer(BreakoutRoomOptionsContainer);

    const buildRows = () =>
        roomState?.map((room) => (
            <BreakoutRoomRowItem key={room.id} roomId={room.id} roomName={room.name} roomUsers={room.users} />
        ));

    if (ready) {
        return <StyledPanelContainer>{buildRows()}</StyledPanelContainer>;
    }

    return <CircularProgress />;
};

export default BreakoutRoomRowCollection;
